document.addEventListener("DOMContentLoaded", function () {
    // Vérifie si l'URL actuelle contient "/pages/ferrari"
    if (window.location.href.includes('/pages/ferrari')) {
        // Ajoute une classe au <body>
        document.body.classList.add('page-ferrari');
    }
});